import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../pages/home/home";
import AboutUs from "../pages/aboutus/aboutus";
import Services from "../pages/services/services";
import Address from "../components/address";
import AppBarMenu from "../components/appbar";
import Footer from "../components/footer";

const NavigationRouter = () => {
  return (
    <BrowserRouter>
      <AppBarMenu />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="*" element={<Address />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default NavigationRouter;
